export default __webpack_public_path__ + "static/media/user.671c2b01.svg";